import { authServiceApi } from "../../../app/authServiceApi";
import { API_URL } from "../../../constants/apiUrl";
import { CommonResponse, GetQueryArgsType } from "../../../types";
import { GetAllPaymentParamsType, GetAllPaymentResponse } from "./payment.type";

export const surveyApi = authServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllPayment: builder.query<
      CommonResponse<GetAllPaymentResponse>,
      GetQueryArgsType<GetAllPaymentParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllPayment,
        ...queryArgs,
      }),
      providesTags: ["GetAllPayment"],
    }),
    sendToPayment: builder.mutation({
      query: ({ data, id }) => ({
        url: `${API_URL.sendToPayment}/${id}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetAllPayment",
            "GetAllJobPost",
            "GetJobAppliedList",
            {
              type: "GetSingleJobApplied",
              id,
            },
          ];

        return [];
      },
    }),
    sendToPaymentPortal: builder.mutation({
      query: ({ data }) => ({
        url: API_URL.sendToPaymentPortal,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetAllPayment"];

        return [];
      },
    }),
  }),
});

export const {
  useGetAllPaymentQuery,
  useSendToPaymentMutation,
  useSendToPaymentPortalMutation,
} = surveyApi;
